import { getObjectValue } from '@services/object-extensions';
import cn from 'classnames';
import styles from './inizio-pagina.module.css';

const InizioPagina = ({ translations = {}, darkTheme = false }) => {
  return (
    <div
      className={cn(`row  align-items-center justify-content-center ${styles.textContainer}`, {
        'snf-text-color-white': darkTheme
      })}
    >
      <div className="col-12 col-md-9">
        <div className="row">
          <div className={`col-12 snf-font-32 snf-font-w6 ${styles.title}`}>
            {getObjectValue(translations, 'title', '')}
          </div>
        </div>
        <div className="row">
          <div className={`col-12 snf-font-16 snf-font-md-24 ${styles.subtitle}`}>
            {getObjectValue(translations, 'subtitle', '')}
          </div>
        </div>
        {/* <div className="row">
          <div className={`col-12 snf-font-20 ${styles.paragraph}`}>
            {getObjectValue(translations, 'paragraph', '')}
          </div>
        </div> */}
      </div>
    </div>
  );
};

InizioPagina.displayName = 'Inizio Pagina';
export { InizioPagina };
